import styles from "./ConsultingDetail.module.css";
import SubPageTop from "../../components/SubPageTop";
import ScrollReveal from "../../components/Ui/ScrollReveal";

const therapyProcessData = [
  {
    id: 1,
    category: "01 컬러 힐링 코칭 상담",
    categoryColor: "#7FC4CF",
    steps: [
      {
        stepNum: "01-1",
        title: "신체 에너지 체크",
        description: "상담 전,후 신체 에너지를 분석하여 현재 상태를 차크라 에너지로 체크"
      },
      {
        stepNum: "01-2",
        title: "컬러 심리 상담",
        description: "12색 컬러비트와 102 감성 컬러카드를 활용하여 내면을 깊이 관찰"
      },
      {
        stepNum: "01-3",
        title: "컬러 에너지 제안",
        description: "본인의 컬러에너지에 해당하는 아로마, 미스트 등을 제안하여 실제 적용"
      }
    ]
  },
  {
    id: 2,
    category: "02 컬러 성격검사",
    categoryColor: "#A8BDD8",
    steps: [
      {
        stepNum: "02-1",
        title: "타고난 컬러 DNA 분석",
        items: [
          "인지컬러/행동컬러로 컬러 성격 분석",
          "자신의 강점과 보완점 파악",
          "공명/비공명 컬러로 현재 심리 체크"
        ]
      },
      {
        stepNum: "02-2",
        title: "보완 컬러 제안",
        items: [
          "결과지 프로파일 제공",
          "공명하는 보석, 아로마 제안",
          "보완컬러 및 기질상담"
        ]
      }
    ]
  }
];

function PersonalTherapy() {
  return (
    <div className={styles.consultingDetail}>
      <SubPageTop title="Consulting" />
      <div className={styles.consultingDetailContent}>
        <ScrollReveal>
          <section className={styles.section01}>
          <div className={styles.imgbox}>
            <img
              src="/image/consulting-detail-section01-07.png"
              alt="컬러 이미지"
            />
          </div>
          <div className={styles.infoBox}>
            <div className={styles.infoHeader}>
              <p className={styles.subtitle}>Color Consulting</p>
              <p className={styles.koTitle}>컬러 테라피 컨설팅</p>
            </div>
            <div className={styles.infoDetail}>
              <div className={styles.infoDesc}>
                컬러 테라피 컨설팅은,
                <br />
                개개인의 내적 성향과 심리상태를 파악하여 셀프 힐링이 가능하도록
                하는 코칭 상담 치유 프로그램 입니다.
              </div>
            </div>
          </div>
        </section>
        </ScrollReveal>
        <ScrollReveal>
          <section className={styles.section02}>
          <div className={styles.titleWrap}>
            <p className={styles.programSubtitle}>process</p>
            <h2 className={styles.title}>컨설팅 프로세스</h2>
          </div>
          <div className={styles.line}></div>
          <div className={styles.therapyWrapper}>
            {therapyProcessData.map((category) => (
              <div key={category.id} className={styles.therapyCategory}>
                <div 
                  className={styles.therapyCategoryHeader}
                  style={{ backgroundColor: category.categoryColor }}
                >
                  <h3 className={styles.therapyCategoryTitle}>{category.category}</h3>
                </div>
                <div className={styles.therapyStepsWrapper}>
                  {category.steps.map((step, index) => (
                    <div key={index} className={styles.therapyStepCard}>
                      <div className={styles.therapyStepLeft}>
                        <h4 className={styles.therapyStepTitle}>{step.title}</h4>
                        <span className={styles.therapyStepNum}>{step.stepNum}</span>
                      </div>
                      <div className={styles.therapyStepRight}>
                        {step.description && (
                          <p className={styles.therapyStepDesc}>{step.description}</p>
                        )}
                        {step.items && (
                          <ul className={styles.therapyStepList}>
                            {step.items.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default PersonalTherapy;